'use strict';

var _ = require('lodash');

var DELIMITER = '__';

var getUniqueDisplayedId = function getUniqueDisplayedId(originalId, itemId) {
    return originalId + DELIMITER + itemId;
};
var updateCompIdInPointersMap = function updateCompIdInPointersMap(_ref, itemId, updatePointerMap) {
    var id = _ref.id;
    return updatePointerMap(id, getUniqueDisplayedId(id, itemId));
};
var isDisplayedComponent = function isDisplayedComponent(compId) {
    return !!getItemId(compId);
};
var getItemId = function getItemId(uniqueItemId) {
    return _.isString(uniqueItemId) ? uniqueItemId.split(DELIMITER)[1] : undefined;
};
var getOriginalId = function getOriginalId(uniqueItemId) {
    return _.isString(uniqueItemId) ? uniqueItemId.split(DELIMITER)[0] : undefined;
};

var uniquePropertyMapperFunctions = {
    dataQuery: getUniqueDisplayedId,
    designQuery: getUniqueDisplayedId,
    id: getUniqueDisplayedId,
    parent: getUniqueDisplayedId,
    layout: function layout(value) {
        return _.cloneDeep(value);
    },
    components: function components(value, itemId, updatePointerMap) {
        return _.map(value, function (child) {
            return _.isString(child) ? getUniqueDisplayedId(child, itemId) : getUniqueStructure(child, itemId, updatePointerMap);
        });
    }
};

function getUniqueStructure(structure, itemId) {
    var updatePointerMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _.noop;

    updateCompIdInPointersMap(structure, itemId, updatePointerMap);
    return _.mapValues(structure, function (value, property) {
        return _.invoke(uniquePropertyMapperFunctions, property, value, itemId, updatePointerMap) || value;
    });
}

function getUniqueFlatStructureMap(compsMap, itemId) {
    var updatePointerMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _.noop;

    return _(compsMap).map(function (comp) {
        return getUniqueStructure(comp, itemId, updatePointerMap);
    }).keyBy('id').value();
}

var originalPropertyMapperFunctions = {
    dataQuery: getOriginalId,
    designQuery: getOriginalId,
    id: getOriginalId,
    layout: function layout(value) {
        return _.cloneDeep(value);
    },
    components: function components(value) {
        return _.map(value, function (child) {
            return child.id ? getOriginalStructure(child) : getOriginalId(child);
        });
    }
};

function getOriginalStructure(itemStructure) {
    return _(itemStructure).omit('parent').mapValues(function (value, property) {
        return _.invoke(originalPropertyMapperFunctions, property, value) || value;
    }).value();
}

module.exports = {
    getUniqueFlatStructureMap: getUniqueFlatStructureMap,
    getUniqueStructure: getUniqueStructure,
    getOriginalStructure: getOriginalStructure,
    isDisplayedComponent: isDisplayedComponent,
    getItemId: getItemId,
    getUniqueDisplayedId: getUniqueDisplayedId,
    getOriginalId: getOriginalId
};
//# sourceMappingURL=displayedOnlyStructureUtil.js.map